import React from "react";
import Toolbar from "./components/Toolbar";
import BlockButton from "./components/toolbar/BlockButton";
import InsertImageButton from "./components/toolbar/InsertImageButton";
import InsertYoutubeVideoButton from "./components/toolbar/InsertYoutubeVideoButton";
import InsertCustomButtonButton from "./components/toolbar/InsertCustomButtonButton";
import MarkButton from "./components/toolbar/MarkButton";
import InsertDividerButton from "./components/toolbar/InsertDividerButton";
import InserSimplecastButton from "./components/toolbar/InsertSimplecastButton";
import InsertSocialMediasButton from "./components/toolbar/InsertSocialMediasButton";
import {
  ICON_FORMAT_ALIGN_CENTER,
  ICON_FORMAT_ALIGN_JUSTIFY,
  ICON_FORMAT_ALIGN_LEFT,
  ICON_FORMAT_ALIGN_RIGHT,
  ICON_FORMAT_BOLD,
  ICON_FORMAT_ITALIC,
  ICON_FORMAT_LIST_BULLETED,
  ICON_FORMAT_LIST_NUMBERED,
  ICON_FORMAT_QUOTE,
  ICON_FORMAT_UNDERLINE,
  ICON_HEADING_FOUR,
  ICON_HEADING_THREE,
} from "./components/Icon";
import ToggleLinkButton from "./components/toolbar/ToggleLinkButton";
import ToolbarLine from "./components/ToolbarLine";
import InsertSubscribeButton from "./components/toolbar/InsertSubscribeButton";

export default function EditorToolbar({ extraToolbarIcons }) {
  return (
    <Toolbar>
      <ToolbarLine>
        <MarkButton format="bold" icon={ICON_FORMAT_BOLD} />
        <MarkButton format="italic" icon={ICON_FORMAT_ITALIC} />
        <MarkButton format="underline" icon={ICON_FORMAT_UNDERLINE} />
        <BlockButton format="heading-three" icon={ICON_HEADING_THREE} />
        <BlockButton format="heading-four" icon={ICON_HEADING_FOUR} />
        <BlockButton format="block-quote" icon={ICON_FORMAT_QUOTE} />
        <BlockButton format="numbered-list" icon={ICON_FORMAT_LIST_NUMBERED} />
        <BlockButton format="bulleted-list" icon={ICON_FORMAT_LIST_BULLETED} />
        <BlockButton format="left" icon={ICON_FORMAT_ALIGN_LEFT} />
        <BlockButton format="center" icon={ICON_FORMAT_ALIGN_CENTER} />
        <BlockButton format="right" icon={ICON_FORMAT_ALIGN_RIGHT} />
        <BlockButton format="justify" icon={ICON_FORMAT_ALIGN_JUSTIFY} />
      </ToolbarLine>
      <ToolbarLine>
        <ToggleLinkButton />
        <InsertImageButton />
        <InsertDividerButton />
        <InsertYoutubeVideoButton />
        <InserSimplecastButton />
        <InsertSocialMediasButton />
        <InsertCustomButtonButton />
        <InsertSubscribeButton />
        {extraToolbarIcons}
      </ToolbarLine>
    </Toolbar>
  );
}
